import React from "react";
import "../Destination/Ftour.css";
import { Link } from "react-router-dom";

const Ftour = () => {
  return (
    <div className="ftour-container">
      {/* Left Section - Oval Image */}
      <div className="ftour-section left-section">
        <div className="oval-image-container">
          <img
            src="/4friend.webp"
            alt="Singapore tour"
            className="oval-image"
          />
        </div>
      </div>

      {/* Middle Section - Text Content */}
      <div className="ftour-section middle-section">
        <div className="discount-badge">30% OFF</div>
        <h2 className="tour-title">London 4</h2>
        <h3 className="tour-subtitle">Friendship Tour</h3>
        <Link to="/tour">
          <button className="discover-button">Discover More</button>
        </Link>
      </div>

      {/* Right Section - Another Image */}
      <div className="ftour-section right-section">
        <img
          src="/ftour.webp"
          alt="Singapore landscape"
          className="right-image"
        />
      </div>
    </div>
  );
};

export default Ftour;
